import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es6.regexp.search";
/* eslint-disable */
/*关联推荐组件
 */
import { toQueryString, toast as _toast, showLoading as _showLoading, hideLoading } from "@ykz/ykz-util/base";
import databus, { Origins } from "@ykz/ykz-http/core";
import { isOtherBrowsers, goToWxMiniPage } from "@ykz/ykz-util/platform";
import { getProductLink } from "@/util/common";
export default {
  name: "appDownload",
  data: function data() {
    return {
      fxbInviteCode: getUrlParams("fxbInviteCode") || "",
      showOffline: false,
      //下线提示框
      showRecommendBox: false,
      //相关推荐弹框
      recommendBoxSlideDown: true,
      //相关推荐弹框是否滑下，false
      moreRecommendSlideDown: true,
      showOutAnimation: false,
      //展示关闭弹框动画

      isOtherBrowser: isOtherBrowsers(),
      //除微信、app外的第三方浏览器打开页面
      isAPP: window.mobileEnv == "app" ? true : false,
      //是否在云客赞app打开页面
      isReviewing: ykzApp.isIOSReviewing(),
      //iOS审核判断，审核版本和上线版本展示样式不同
      isShop: sessionStorage.getItem("session_isShop") || "",
      //店铺模式
      weChatId: getUrlParams("weChatId") || window.weChatId,
      weChatType: window.comm.weChatType || 1,
      //1：直采和直销，2：市区娱乐(微商城)，3：渠道SIP直连，4：旅行社/综合类'(微商城)
      goodId: getUrlParams("goodId") || "",
      //商品id
      simData: getUrlParams("simData") || "",
      //模拟假数据的参数
      pageType: function () {
        if (location.href.search(/ticketProductDetails/) != -1) {
          return 1;
        } else if (location.href.search(/entranceTicketDetails/) != -1) {
          return 2;
        } else if (location.href.search(/specialDetails/) != -1) {
          return 3;
        } else if (location.href.search(/showTicketDetails/) != -1) {
          return 4;
        } else {
          return 0;
        }
      }(),
      //详情页页面类型，0.未知  1.票券  2.门票或微客房  3.特产  4.演出票

      scenicId: "",
      //酒景id
      storeId: "",
      //门店id
      recommendList: [],
      //相关推荐列表
      expand: false,
      //展开
      showMoreRecommend: false,
      two_height: 0,
      //recommend-list容器仅有二个元素高度
      all_height: 0 //recommend-list容器有全部元素高度
    };
  },

  props: {
    type: {},
    stockShow: {},
    jumpLink: {},
    hotelId: {},
    isPromoter: {},
    isExpired: {},
    isHide: {},
    //隐藏相关推荐（套餐）
    product: {}
  },
  watch: {
    showOffline: function showOffline(val) {
      !this.isOtherBrowser && this.setOverflow(val);
    },
    showRecommendBox: function showRecommendBox(val) {
      this.setOverflow(val);
    }
  },
  computed: {
    currentPrice: function currentPrice() {
      var tempPrice = ((this.product.activityId ? this.product.activityPrice : this.product.sellPrice) || 0).toFixed(1);
      var _tempPrice$split = tempPrice.split("."),
        _tempPrice$split2 = _slicedToArray(_tempPrice$split, 2),
        yuanText = _tempPrice$split2[0],
        fenText = _tempPrice$split2[1];
      fenText = fenText !== "0" ? fenText : ""; // 价格为整数，不显示分
      return {
        yuanText: yuanText,
        fenText: fenText
      };
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
    window.componentCenter.relatedRecommend = this;
  },
  methods: {
    //向上滑动显示相关推荐弹框弹框
    slideUpMoreRecommend: function slideUpMoreRecommend(_this) {
      this._this != _this && (this._this = _this || {});
      var that = this;
      that.showMoreRecommend = true;
      setTimeout(function () {
        that.moreRecommendSlideDown = false;
      }, 30);
      YCF_Plugin.anchorPoint("商品套餐详情_全部", "gooddetail_details_all", "goodId:".concat(this.goodId));
    },
    //向下滑动隐藏相关推荐弹框弹框
    slideDownMoreRecommend: function slideDownMoreRecommend() {
      var that = this;
      that.moreRecommendSlideDown = true;
      setTimeout(function () {
        that.showMoreRecommend = false;
      }, 300);
    },
    //兼容ios系统的overflow对z-index层级关系的影响
    setOverflow: function setOverflow(val) {
      if (val) {
        $(".scroll-area").css("overflow-y", "hidden");
      } else {
        $(".scroll-area").css("overflow-y", "auto");
      }
    },
    //toast
    toast: function toast(str) {
      _toast(str);
    },
    //Loading
    showLoading: function showLoading() {
      _showLoading({
        cover: true,
        opacity: 0
      });
    },
    //隐藏商品已下架弹框
    hideBox: function hideBox() {
      var that = this,
        timer = null;
      this.showOutAnimation = true;
      timer = setTimeout(function () {
        clearTimeout(timer);
        that.showOutAnimation = false;
        that.showOffline = false;
      }, 200);
      this.reportUserAnchors("500126");
    },
    // 弹窗展示更多的套餐
    showMoreRecommendList: function showMoreRecommendList() {
      this.slideUpMoreRecommend();
    },
    //跳转到产品详情页
    goProductDetailPage: function goProductDetailPage(recommend) {
      var urlStr = getProductLink({
        cateId: recommend.cateId,
        weChatId: recommend.weChatId,
        goodsId: recommend.goodsId,
        activityId: recommend.activityId,
        isActivity: recommend.isActivity,
        hotelId: recommend.hotelId,
        hotelScenicId: this.scenicId,
        storeId: this.storeId
      }, "mini");
      if (urlStr) {
        var properties = {};
        var queryData = {
          channel: this.type == 1 ? "productDetailRelevant" : "productDetailEnd"
        };
        if (urlStr.includes("roomReserve")) {
          // 微客房直接进入预订页需要携带SKUID
          queryData.skuId = recommend.skuId;
        }
        urlStr += toQueryString(queryData);
        properties.good_id = recommend.goodsId;
        properties.type = "product";
        YCF_Plugin.reportUserAnchors({
          event_id: "520009",
          properties: properties
        }).always(function () {
          // window.location.href = urlStr;
          goToWxMiniPage(urlStr);
        });
      } else {
        this.toast("未知的产品类型！");
      }
    },
    //看看其他商品
    goTicketListPage: function goTicketListPage(event_id) {
      var that = this;
      that.reportUserAnchors(event_id, function () {
        if (that.isAPP) {
          ykzApp.ready(function () {
            ykzApp.toAppIndex && ykzApp.toAppIndex({
              hash: "1"
            });
          });
        } else if (that.fxbInviteCode) {
          window.location.href = "/front/promoter/fxbIndex?weChatId=" + that.weChatId;
        } else if (that.isShop) {
          window.location.href = "/front/promoter/myShop?weChatId=" + that.weChatId + "&promotion=" + (sessionStorage.getItem("isShop_promotion") || "");
        } else if (that.jumpLink) {
          window.location.href = that.jumpLink;
        } else if (that.weChatId == 302) {
          window.location.href = "/front/platform/index?weChatId=421";
        } else if (that.weChatType == 1 && that.pageType != 4) {
          if (that.pageType == 1) {
            window.location.href = "/front/index/ticketList?weChatId=" + that.weChatId + "&productType=3";
          } else if (that.pageType == 2) {
            window.location.href = "/front/index/entranceTicketList?weChatId=" + that.weChatId + "&hotelId=" + that.hotelId;
          } else if (that.pageType == 3) {
            window.location.href = "/front/index/ticketList?weChatId=" + that.weChatId + "&productType=7";
          } else {
            //未知页面
            window.location.href = "/front/platform/index?weChatId=" + that.weChatId;
          }
        } else {
          window.location.href = "/front/platform/index?weChatId=" + that.weChatId;
        }
      });
    },
    //判断奖励字段是否需要显示
    getIsShow: function getIsShow(value) {
      if (!value || typeof value != "string") {
        return false;
      }
      var numStr = value.replace(/[^0-9]+/g, "");
      if (numStr && numStr != 0) {
        return true;
      } else {
        return false;
      }
    },
    //大数据锚点
    reportUserAnchors: function reportUserAnchors(event_id, callback) {
      YCF_Plugin.reportUserAnchors({
        event_id: event_id,
        event_content: {
          item_id: this.goodId
        }
      }).always(callback);
    },
    //向上滑动显示相关推荐弹框弹框
    slideUpRecommendBox: function slideUpRecommendBox() {
      if (!this.recommendList.length) {
        this.showOffline = true;
        return;
      }
      var that = this;
      that.showRecommendBox = true;
      setTimeout(function () {
        that.recommendBoxSlideDown = false;
      }, 30);
    },
    //向下滑动隐藏相关推荐弹框弹框
    slideDownRecommendBox: function slideDownRecommendBox() {
      var that = this;
      that.recommendBoxSlideDown = true;
      setTimeout(function () {
        that.showRecommendBox = false;
      }, 300);
    },
    //获取相关推荐列表
    getRecommendList: function getRecommendList(storeId) {
      var that = this;
      //关联推荐仅在421公众号才展示
      if (this.weChatId != 421 || this.isHide) {
        this.type == 2 && setTimeout(function () {
          that.showOffline = true;
        }, 500);
        return false;
      }
      databus({
        url: "/apiv2/marketing/getScenicGoodsByGoodsId",
        data: {
          goodsId: getUrlParams("goodId") || "",
          source: that.isAPP ? 1 : 0,
          storeId: storeId || "",
          isShop: sessionStorage.getItem("session_isShop") || ""
        },
        type: "get",
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            res.content = res.content || {};
            that.scenicId = res.content.scenicId || "";
            that.storeId = res.content.storeId || "";
            that.recommendList = res.content.goodsList || [];
          }
        },
        error: function error() {
          console.log("网络有误");
        },
        complete: function complete() {
          if (that.type != 1) {
            if (that.recommendList.length) {
              that.$nextTick(function () {
                setTimeout(function () {
                  that.slideUpRecommendBox();
                }, 500);
              });
            } else {
              that.showOffline = true;
            }
          }
        }
      });
    }
  }
};